import { GridProvider, useEntity } from 'Context';
import { ReferralsFilteredGrid } from 'Features/Referrals';
import React from 'react';

export const ClaimReferrals: React.FC = () => {
  const entity = useEntity();

  return (
    <GridProvider entityName="Referral">
      <ReferralsFilteredGrid id={entity.id} />
    </GridProvider>
    )
};
